import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TomiSection } from './components/TomiSection';
import { LookInside } from './components/LookInside';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization (hardened against sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '2828062277586055');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      // Pixel must never crash the page (e.g. cross-origin / sandbox)
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="sund47ok4egl">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2828062277586055&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="su45bjsmf6ga" />
      </noscript>
      <div className="min-h-screen bg-brand-cream text-brand-graphite overflow-x-hidden selection:bg-brand-gold/30" data-id="element-2" data-mp="3uc9inv5c9kir">
        <UrgencyBanner data-id="element-3" data-mp="d2l7j27ii10b" />
        <Hero data-id="element-4" data-mp="85uj9rljzz3t" />
        <PainSection data-id="element-5" data-mp="851hl51gbzsj" />
        <TomiSection data-id="element-6" data-mp="86w76wno4g2y" />
        <LookInside data-id="element-7" data-mp="86ckz3qzj5j4" />
        <BonusSection data-id="element-8" data-mp="3gle7udba4tcj" />
        <PricingCard data-id="element-9" data-mp="3gkv2dw2tfxfe" />
        <Guarantee data-id="element-10" data-mp="3gmfsn9i3ku7g" />
        <Testimonials data-id="element-11" data-mp="3glnzs6fvxakv" />
        <FAQ data-id="element-12" data-mp="3gj1qa19fol00" />
        <FinalCTA data-id="element-13" data-mp="3bmjqlfsyncuj" />
        <Footer data-id="element-14" data-mp="3bn2ye3owckuu" />
      </div>
    </>;
}